import React from 'react';
import { ClientList } from './ClientList';
import { ClientFilters } from './ClientFilters';
import { ClientSearch } from './ClientSearch';
import { Plus } from 'lucide-react';

export function ClientManagement() {
  const [searchQuery, setSearchQuery] = React.useState('');
  const [selectedFilter, setSelectedFilter] = React.useState('all');

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">Client Management</h1>
        <button className="theme-button px-4 py-2 rounded-lg flex items-center gap-2">
          <Plus className="w-4 h-4" />
          Add Client
        </button>
      </div>

      <div className="flex flex-col sm:flex-row gap-4">
        <div className="flex-1">
          <ClientSearch value={searchQuery} onChange={setSearchQuery} />
        </div>
        <ClientFilters selected={selectedFilter} onSelect={setSelectedFilter} />
      </div>

      <ClientList searchQuery={searchQuery} filter={selectedFilter} />
    </div>
  );
}